




import { Component, Vue, Prop } from "vue-property-decorator";
import { ATMAsset, ATMPair } from "@foxone/api/src/models/market";

@Component
class StrategyTips extends Vue {
  @Prop() asset!: ATMAsset;

  @Prop() isBuy!: boolean;

  @Prop() pair!: ATMPair;

  @Prop() quantifyErrorMessage;

  @Prop() balance;

  @Prop() quantityValue;

  get balanceText() {
    return `${this.balance} ${(this.asset && this.asset.symbol) || ""}`;
  }

  get fee() {
    if (!this.pair || !this.asset || !this.quantityValue) return "";
    const { base, bid_fee, ask_fee } = this.pair;
    const rate = base.symbol === this.asset.symbol ? ask_fee : bid_fee;
    const amount = (Number(rate) * Number(this.quantityValue)).toFixed(
      base.precision
    );
    return `≈${amount} ${this.asset.symbol}`;
  }

  get tips() {
    const offerAsset = this.asset;
    const pair = this.pair;
    if (!offerAsset || !pair) {
      return [];
    }
    const unit = pair.quote.symbol;
    const asset =
      pair.base.symbol === offerAsset.symbol ? pair.base : pair.quote;
    const tips: any[] = [];
    const min =
      (asset.minimums && asset.minimums && asset.minimums.flex) ||
      asset.min ||
      0;

    // error tip
    tips.push({
      text: this.quantifyErrorMessage,
      hide: !this.quantifyErrorMessage,
      error: true
    });

    // market info
    if (this.pair) {
      tips.push({
        text: this.$t("trade.auto.tip.current-price", {
          price: `${this.pair.price} ${unit}`
        })
      });
      if (this.isBuy) {
        tips.push({
          text: this.$t("trade.auto.tip.buy-1-price", {
            price: `${this.pair.price_buy} ${unit}`
          })
        });
      } else {
        tips.push({
          text: this.$t("trade.auto.tip.sell-1-price", {
            price: `${this.pair.price_sell} ${unit}`
          })
        });
      }
    }

    if (this.fee) {
      tips.push({
        text: this.$t("common.fee-amount", { amount: this.fee }),
        hide: !this.fee
      });
    }

    // balance tip
    tips.push({
      component: "base-balance-field",
      type: "component",
      hide: this.balance === null
    });

    // limit tip
    tips.push({
      text: this.$t("common.amount.limit", {
        min: `${min} ${asset.symbol}`,
        max: "-"
      })
    });

    return tips.filter(tip => !tip.hide);
  }
}
export default StrategyTips;
